import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { supabase } from '../client/client';

// Portadas de las ediciones. Antes estaban escritas a mano en este archivo,
// apuntando a imágenes sueltas de /public; ahora se leen de la tabla "revistas"
// y las portadas viven en el bucket, así que se pueden añadir o retirar sin
// tocar el código.
function Slider() {
  const [revistas, setRevistas] = useState([]);

  useEffect(() => {
    const cargarRevistas = async () => {
      const { data, error } = await supabase
        .from('revistas')
        .select('id, numero, titulo, image_url, enlace')
        .eq('visible', true)
        .order('numero', { ascending: false });

      if (error) {
        console.error('Error al cargar las revistas:', error);
        return;
      }
      setRevistas(data || []);
    };

    cargarRevistas();
  }, []);

  if (revistas.length === 0) return null;

  return (
    <div className="w-full py-6 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <Swiper
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          spaceBetween={16}
          slidesPerView={6}
          navigation
          // El modo cíclico necesita bastantes más diapositivas que las visibles;
          // con menos, Swiper descoloca la primera y deja un hueco al final.
          loop={revistas.length > 12}
          watchOverflow={true}
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          grabCursor={true}
          speed={800}
          breakpoints={{
            0: { slidesPerView: 2 },
            480: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 6 },
          }}
        >
          {revistas.map((revista) => (
            <SwiperSlide key={revista.id}>
              <a
                href={revista.enlace}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center"
              >
                {/* La clase reserva la caja por proporción antes de que la
                    imagen cargue. Sin altura previa, una imagen diferida nunca
                    llega a entrar en pantalla y no se descarga jamás. */}
                <img
                  src={revista.image_url}
                  alt={`Portada de ${revista.titulo}`}
                  className="ed-portada-revista"
                  loading="lazy"
                  decoding="async"
                />
                <h2 className="slider-text_revistas">{revista.titulo}</h2>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default Slider;
